import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { FundsInformFieldsAsset, InvestorInformation } from "../partials/FormFields";
import { ApprenticeLists } from "../partials/ApprenticeLists";

// eslint-disable-next-line no-unused-vars
const CreatedAssetsForm = ({ AFdata, setAFdata, updateCurrentObject }) => {
	const [formData, setFormData] = useState(AFdata);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(AFdata);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setAFdata(formData);
		updateCurrentObject(formData);
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar AFdata={formData} handleCancel={handleCancel} />

				<div className='RightSection'>
					<FormAccordion title='Funds Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<FundsInformFieldsAsset
								formData={formData}
								isEditable={isEditable}
								handleInputChange={handleInputChange}
								except={["approvalStatus", "disbursement"]}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='Investor’s Information' open={true}>
						<InvestorInformation formData={formData} />
					</FormAccordion>

					{formData?.status !== "inactive" && (
						<FormAccordion title='Apprentices List' open={true}>
							{formData?.apprentice?.length > 0 ? (
								<ApprenticeLists apprenticesList={formData?.apprentice} />
							) : (
								<p style={{ fontWeight: "500" }}>No apprentice has requested this finance yet.</p>
							)}
						</FormAccordion>
					)}

					{/* <FormAccordion title='Identification' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<IdentificationGroup formData={formData} />
						</div>
					</FormAccordion> */}

					{/* <FormAccordion title='Power of Attorney' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<SelectFieldStatus
									name='powerOfAttorney'
									handleChange={handleInputChange}
									value={formData?.powerOfAttorney}
									type={formData?.powerOfAttorney ? "success" : "error"}
								/>
							</div>
						</div>
					</FormAccordion> */}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
CreatedAssetsForm.propTypes = {
	AFdata: PropTypes.object,
	setAFdata: PropTypes.func,
	updateCurrentObject: PropTypes.func,
};

export default CreatedAssetsForm;
